import _ from 'lodash';
import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { generateClient } from '@aws-amplify/api';
import { getSegments as _getSegments } from '@/graphql/queries';
import ErrorModal from '@/ErrorModal';
import DataSegments from './detail';
import SegmentSummary from './summary';
import { transformSchemaToSegmentState } from '@/utils/segmentUtils';
import Header from '@/Header';
import Breadcrumb from '@/Breadcrumb';

const client = generateClient();

const getObject = ({ id }) => {
	return client.graphql({ query: _getSegments, variables: { id } })
		.then(response => {
			return response.data.getSegments.segments?.[0];
		});
};

export default ({ links = [] }) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [formData, setFormData] = useState();
	const [activeForm, setActiveForm] = useState('detail');
	const [errorMessage, setErrorMessage] = useState();
	const { id } = useParams();
	const isConstructed = useRef(false);

	const catchError = error => {
		if (error instanceof Error) {
			setErrorMessage(error.toString());
		} else {
			setErrorMessage((error.errors || []).map(e => e.message?.toString()));
		}
		setIsLoaded(true);
	};

	if (!isConstructed.current) {
		isConstructed.current = true;
		if (!isLoaded) {
			if (id === 'new') {
				setIsLoaded(true);
			} else {
				getObject({ id })
					.then(data => {
						const formData = transformSchemaToSegmentState(data);
						setFormData({
							formData,
							oldFormData: _.cloneDeep(formData)
						});
						setIsLoaded(true);
					})
					.catch(catchError);
			}
		}
	}

	return (
		<>
			{errorMessage && <ErrorModal message={errorMessage} onClose={() => setErrorMessage()} title="Error" />}
			<div className="container-fluid px-4 position-relative">
				<Header>
					{links.length > 0 && <Breadcrumb className="mb-3 mx-3" links={links} />}
				</Header>
				{!isLoaded ? (
					<div className="text-center" style={{marginTop:'5rem'}}>
						<button className="btn btn-primary" type="button" disabled>
							<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				) : (
					<div className="container-fluid px-3">
						{ activeForm === 'detail' && <DataSegments formData={formData} links={links} setActiveForm={setActiveForm} setFormData={setFormData} />}
						{ activeForm === 'summary' && <SegmentSummary formData={formData} links={links} setActiveForm={setActiveForm} />}
					</div>
				)}
			</div>
		</>
	);
};
